<app-batch-item
    [initialTask]="data?.initialState?.task"
    [showCloseButton]="true">
</app-batch-item>
